import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  padding-top: ${({ searchMode, subHeaderHeight, showHeaderGroceries }) => {
    if (searchMode && !subHeaderHeight && showHeaderGroceries) return '150px';
    if (searchMode && !subHeaderHeight) return '120px';
    if (searchMode && subHeaderHeight) return subHeaderHeight;
    return 0;
  }};
  margin-bottom: ${({ withMargin }) => withMargin && '12px'};
`;

export default Container;
